import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    formWrapper: {
      margin: `${theme.spacing(8)} auto 0`,
      maxWidth: "100%",
      width: "872px",
    },
    tooltipTitle: {
      fontSize: 14,
      fontWeight: 500,
      color: theme.gray800,
    },
    tooltipText: {
      fontSize: 12,
      marginTop: theme.spacing(4),
    },
    keyNameInput: {
      marginTop: theme.spacing(6),
    },
    dateTimeInput: {
      marginTop: theme.spacing(12),
    },
    modal: {
      width: 536,
    },
    copyTokenInfo: {
      whiteSpace: "break-spaces",
      fontSize: 14,
      color: theme.gray500,
      lineHeight: "17px",
      marginBottom: theme.spacing(18),
    },
    copyTokenInput: {
      "& input": {
        textOverflow: "ellipsis",
        paddingRight: theme.spacing(10),
      },
    },
    copyIcon: {
      color: theme.gray400,
      cursor: "pointer",
      fontSize: 15,
    },
    tokenInput: {
      backgroundColor: theme.gray50,
      "& > label": {
        color: `${theme.gray800} !important`,
      },
      "& > div > input": {
        "-webkit-text-fill-color": `${theme.gray800} !important`,
      },
    },
    tokenInfo: {
      fontSize: 14,
      color: theme.gray500,
      marginTop: theme.spacing(4),
    },
    iconBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "50%",
      width: theme.spacing(12),
      minWidth: theme.spacing(12),
      height: theme.spacing(12),
      background: theme.gray100,
      margin: theme.spacing(0, 4),
      cursor: "pointer",
    },
    icon: {
      width: theme.spacing(8),
      height: theme.spacing(8),
      color: theme.gray500,
    },
    expired: {
      color: theme.red500,
    },
    emptyState: {
      paddingBottom: 0,
    },
  }),
);
